var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPrint(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "descargar_imprimir",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_223",
    "data-name": "Rect\\xE1ngulo 223",
    width: 30,
    height: 30,
    transform: "translate(851 700)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_21",
    "data-name": "Rect\\xE1ngulo 21",
    width: 16,
    height: 14.754,
    fill: "#707070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_34",
    "data-name": "Enmascarar grupo 34",
    transform: "translate(-851 -700)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14",
    "data-name": "Grupo 14",
    transform: "translate(858 707.623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13",
    "data-name": "Grupo 13",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M16,4.641a1.143,1.143,0,0,0-1.241-1.232H13.079V3.22q0-1.3,0-2.609c0-.445-.167-.61-.615-.61H3.526c-.437,0-.607.168-.607.6q0,1.3,0,2.594v.212H2.747c-.5,0-1,.013-1.5,0a1.157,1.157,0,0,0-1.231.947c0,.009-.011.017-.017.025v6.531a1.387,1.387,0,0,0,.338.638,1.186,1.186,0,0,0,.852.328h1.73v.2q0,1.039,0,2.078c0,.427.172.6.594.6h8.969c.424,0,.6-.172.6-.6q0-1.039,0-2.078v-.206h1.679A1.146,1.146,0,0,0,16,10.641q0-3,0-6M3.9.975h8.2V3.4H3.9Zm8.2,12.8H3.9V9H12.1Zm2.685-2.874H13.079V10.7c0-.7,0-1.4,0-2.093,0-.4-.178-.579-.583-.579h-9c-.4,0-.578.177-.579.583q0,1.047,0,2.093v.2c-.059,0-.1.009-.15.009H1.223c-.21,0-.255-.046-.255-.258q0-3.007,0-6.014c0-.213.043-.257.254-.257H14.781c.2,0,.25.045.25.246q0,3.015,0,6.03c0,.2-.047.253-.244.253",
    transform: "translate(0.001 0)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11",
    "data-name": "Trazado 11",
    d: "M266.42,122.98a.694.694,0,0,0-.686.686.687.687,0,1,0,.686-.686",
    transform: "translate(-253.826 -117.469)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12",
    "data-name": "Trazado 12",
    d: "M119.1,222.813c.729,0,1.457,0,2.186,0s1.447,0,2.17,0a.485.485,0,1,0-.016-.966c-.729,0-1.457,0-2.186,0-.7,0-1.405,0-2.108,0a.5.5,0,0,0-.5.3.477.477,0,0,0,.457.67",
    transform: "translate(-113.288 -211.905)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13",
    "data-name": "Trazado 13",
    d: "M123.476,264.852c-.723,0-1.447,0-2.17,0h-.921c-.432,0-.864,0-1.3,0a.472.472,0,0,0-.471.466.48.48,0,0,0,.434.487,1.3,1.3,0,0,0,.171.009h4.152a1.239,1.239,0,0,0,.217-.015.45.45,0,0,0,.367-.322.475.475,0,0,0-.485-.627",
    transform: "translate(-113.303 -252.981)",
    fill: "#707070"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrint);
export default __webpack_public_path__ + "static/media/icon_print.c24a0bc8ec8f89860c0fd3ed14104207.svg";
export { ForwardRef as ReactComponent };